module.exports = __webpack_public_path__ + "img/logo_be_a_racer.f56ede90.svg";